import { render, staticRenderFns } from "./MetricsReport.vue?vue&type=template&id=728a67b2"
import script from "./MetricsReport.vue?vue&type=script&lang=js"
export * from "./MetricsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports